import { useEffect, useState } from 'react';

/**
 * Loads src/content/packages/<id>.json if it exists (each file is its own small
 * download, so only the package being viewed is fetched). Returns null when the
 * package has no rewritten content yet.
 */
export default function usePackageContent(id) {
  const [state, setState] = useState({ id: null, content: null, loading: !!id });

  useEffect(() => {
    let alive = true;
    if (!id || !/^[a-z0-9-]+$/i.test(id)) { setState({ id, content: null, loading: false }); return undefined; }
    setState({ id, content: null, loading: true });
    import(/* webpackChunkName: "pkg-[request]" */ `../../content/packages/${id}.json`)
      .then((m) => { if (alive) setState({ id, content: m.default || m, loading: false }); })
      .catch(() => { if (alive) setState({ id, content: null, loading: false }); });
    return () => { alive = false; };
  }, [id]);

  return state.id === id ? state : { id, content: null, loading: true };
}
